import React, { useState } from 'react';
import { apiPost } from '../../api';
import { toast } from 'react-toastify';
import ConfirmationModal from '../../components/ConfirmationModal';

const UpdatePassword = () => {
  const [form, setForm] = useState({ currentPassword: '', password: '', confPassword: '' });
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confPassword) {
      toast.error('Passwords do not match');
      return;
    }
    setShowConfirmModal(true);
  };

  const confirmUpdatePassword = async () => {
    setLoading(true);
    try {
      await apiPost('/api/admin/account/profile/update-password', form);
      toast.success('Password updated successfully');
      setForm({ currentPassword: '', password: '', confPassword: '' });
      setShowConfirmModal(false);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30";
  const labelCls = "block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5";

  return (
    <div className="max-w-lg mx-auto">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground mb-1">
        Change <span className="text-gradient-ginox">Password</span>
      </h1>
      <p className="text-sm text-muted-foreground mb-6">
        Update your account password
      </p>

      <div className="border-t border-white/[0.08] pt-6">
        <h2 className="text-[10px] font-medium uppercase tracking-[1.5px] text-muted-foreground/60 mb-5">
          Password Details
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className={labelCls}>Current Password</label>
            <input
              type="password"
              name="currentPassword"
              value={form.currentPassword}
              onChange={handleChange}
              className={inputCls}
              required
            />
          </div>
          <div>
            <label className={labelCls}>New Password</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              className={inputCls}
              required
            />
          </div>
          <div>
            <label className={labelCls}>Confirm New Password</label>
            <input
              type="password"
              name="confPassword"
              value={form.confPassword}
              onChange={handleChange}
              className={inputCls}
              required
            />
          </div>
          <div className="pt-2">
            <button
              type="submit"
              disabled={loading}
              className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50"
            >
              {loading ? 'Saving...' : 'Save Password'}
            </button>
          </div>
        </form>
      </div>

      <ConfirmationModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirm={confirmUpdatePassword}
        title="Update Password"
        message="Are you sure you want to update your password? You will need to use the new password for your next login."
        confirmText="Update Password"
        loading={loading}
        loadingText="Updating..."
      />
    </div>
  );
};

export default UpdatePassword;
